export default "__VITE_ASSET__BCu9VTuY__"